export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.scanme.am/api',
  frontUrl: 'https://dev.scanme.am/',
};
